// const offices = [
  
//   {
//     city: "Pune",
//     label: "Head Office",
//     lines: [
//       "Flat 304, Plot-82, Prathmesh Krupa,",
//       "Purnanagar / Chikhali,",
//       "Pune – 411019",
//     ],
//   },
//   {
//     city: "Mumbai",
//     label: "Corporate Office",
//     lines: [
//       "B/503, 5th Floor, Twin Arcade,",
//       "Military Road, Marol, Andheri East,",
//       "Mumbai – 400059",
//     ],
//   },
//   {
//     city: "Mumbai",
//     label: "Branch Office",
//     lines: [
//       "Vasant Oasis, Makwana Rd,",
//       "Marol, Andheri East,",
//       "Mumbai, Maharashtra – 400059",
//     ],
//   },
  
//   {
//     city: "Ahmedabad",
//     label: "Office",
//     lines: [
//       "Block No. – F 410, Praladnagar Trade Center,",
//       "Vejalpur, Ahmedabad, Gujarat – 380015",
//     ],
//   },
//   {
//     city: "Bengaluru",
//     label: "Branch Office",
//     lines: [
//       "No 002, First Floor,",
//       "Ramachandrapura Main Road,",
//       "SKY Bazar, Vidyaranyapura Post,",
//       "Bengaluru – 560097",
//     ],
//   },
// ];








import React from "react";


const BRAND = {
  primary: "#0A88D3",   
  dark: "#0B2447",
  accent: "#00C2FF",
  soft: "rgba(10,136,211,0.12)",
};

const CITY_COLORS = {
  Mumbai: BRAND.primary,
  Pune: "#0EA5E9",
  Ahmedabad: "#1BA97F",
  Bengaluru: "#7C3AED",
};





const offices = [
  {
    city: "Pune",
    label: "Head Office",
    company: "Aaryan Travels",
    lines: [
      "Flat 304, Plot-82, Prathmesh Krupa,",
      "Purnanagar / Chikhali,",
      "Pune – 411019",
    ],
    phone: "+91 9730707888",
  },

  {
    city: "New Delhi",
    label: "Branch Office",
    company: "Aaryan Travels",
    lines: [
      "Flat No.4, Kh.No.439, Shahbad Mohammad Pur,",
      "Extn., New Delhi – 110061",
    ],
     phone: "+91 9730707888",
  },

  {
    city: "Mumbai",
    label: "Corporate Office",
    company: "Aaryan Travels",
    lines: [
      "B/503, 5th Floor, Twin Arcade,",
      "Military Road, Marol, Andheri East,",
      "Mumbai – 400059",
    ],
     phone: "+91 9730707888",
  },

  {
    city: "Ahmedabad",
    label: "Branch Office",
       company: "Aaryan Travels",
    lines: [
      "Block No. – F 410, Praladnagar Trade Center,",
      "Vejalpur, Ahmedabad, Gujarat – 380015",
    ],
     phone: "+91 9730707888",
  },

  {
    city: "Mumbai",
    label: "Branch Office",
        company: "Aaryan Travels",
    lines: [
      "Vasant Oasis, Makwana Rd,",
      "Marol, Andheri East,",
      "Mumbai, Maharashtra – 400059",
    ],
     phone: "+91 9730707888",
  },

  {
    city: "Bengaluru",
    label: "Branch Office",
    company: "Aaryan Travels",
    lines: [
      "No 002, First Floor,",
      "Ramachandrapura Main Road,",
      "SKY Bazar, Vidyaranyapura Post,",
      "Bengaluru – 560097",
    ],
     phone: "+91 9730707888",
  },
];

const InfoCard = ({ icon, title, items }) => (
  <div className="cu-card">
    <div className="cu-card__icon">
      <img src={icon} alt="" />
    </div>
    <h5 className="cu-card__title">{title}</h5>
    <div className="cu-card__content">
      {items.map((it, i) =>
        typeof it === "string" ? (
          <p key={i} className="cu-line">
            {it}
          </p>
        ) : (
          <p key={i} className="cu-line">
            <a className="cu-link" href={it.href}>
              {it.text}
            </a>
          </p>
        )
      )}
    </div>
  </div>
);

const OfficeCard = ({ city, label, lines, company, phone }) => {
  const tint = CITY_COLORS[city] || BRAND.primary;
  return (
    <div className="office-card">
      <div className="office-card__badge" style={{ backgroundColor: tint }}>
        {city}
      </div>
      <div className="office-card__body">
        <h6 className="office-card__title">{label}</h6>
        <h6 className="">{company}</h6>
       
        <p className="office-card__addr">
          {lines.map((l, i) => (
            <span key={i}>
              {l}
              {i !== lines.length - 1 && <br />}
            </span>
          ))}
        </p>
         <p className="">{phone}</p>
      </div>
    </div>
  );
};

const ContactUs = () => {
  return (
    <>
      {/* Hero */}
      <header className="cu-hero">
        <div className="cu-hero__overlay" />
        <div className="container">
          <div className="cu-hero__content">
           
            <div>
              <h1 className="text-center">Contact Us</h1>
              <p className="text-center">Travel with Luxury and Comfort</p>
            </div>
          </div>
        </div>
        <div className="cu-hero__curve" />
      </header>

      {/* Top Info */}
      <section className="section">
        <div className="container">
          <div className="cu-section-head pt-5">
            <h2>We’d love to hear from you</h2>
            <p className="muted">
              Reach us via phone, email, or visit any of our offices below.
            </p>
          </div>

          <div className="cu-grid">
            <InfoCard
              icon="/images/icon-phone.svg"
              title="Call Us"
              items={[
                { text: "+91 97307 07888", href: "tel:+919730707888" },
                { text: "+91 98333 77051", href: "tel:+919833377051" },
              ]}
            />
            <InfoCard
              icon="/images/icon-mail.svg"
              title="Email"
              items={[
                {
                  text: "pramod@aaryantravels.com",
                  href: "mailto:pramod@aaryantravels.com",
                },
                {
                  text: "sales@aaryantravels.com",
                  href: "mailto:sales@aaryantravels.com",
                },
                {
                  text: "bookings@aaryantravels.com",
                  href: "mailto:bookings@aaryantravels.com",
                },
              ]}
            />
            <InfoCard
              icon="/images/whatsapp.webp"
              title="WhatsApp"
              items={[
                {
                  text: "Chat with us",
                  href:
                    "https://wa.me/919730707888?text=Hi%20Aaryan%20Travels%2C%20I%20have%20a%20booking%20enquiry.",
                },
              ]}
            />
          </div>
        </div>
      </section>

      {/* Offices */}
      <section className="section section--soft">
        <div className="container">
          <div className="cu-section-head">
            <h3>Our Offices</h3>
          </div>

          <div className="office-grid">
            {offices.map((o, idx) => (
              <OfficeCard key={idx} {...o} />
            ))}
          </div>
        </div>
      </section>

     

      {/* Map */}
      <section className="section">
        <div className="container">
          <div className="cu-section-head">
            {/* <h3>Location</h3> */}
          </div>
          <div className="map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin"
              width="100%"
              height="460"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              title="Aaryan Travels Location"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
